import { Fragment } from 'react';

import { Panel } from '../../ui/Panel/Panel';
import { EmptyState } from '../../ui/EmptyState/EmptyState';
import { IconButton } from '../../ui/IconButton/IconButton';
import { SearchField } from '../../ui/SearchField/SearchField';
import { ArrowDownIcon } from '../../../assets/icons/icons';
import type { NewsItem } from '../../../types/news';
import { formatDate } from '../../../utils/date';
import { NewsListItem } from '../NewsListItem/NewsListItem';
import styles from './NewsList.module.scss';

interface NewsListProps {
    items: NewsItem[];
    activeId: string | null;
    query: string;
    isNewestFirst: boolean;
    isFiltered: boolean;
    onQueryChange: (value: string) => void;
    onToggleOrder: () => void;
    onSelect: (id: string) => void;
    onReset: () => void;
}

export function NewsList({
    items,
    activeId,
    query,
    isNewestFirst,
    isFiltered,
    onQueryChange,
    onToggleOrder,
    onSelect,
    onReset,
}: NewsListProps) {
    let renderedDate = '';

    return (
        <Panel>
            <div className={styles.head}>
                <SearchField value={query} placeholder="Заголовок или текст" onChange={onQueryChange} />

                <IconButton
                    label={isNewestFirst ? 'Сначала новые' : 'Сначала старые'}
                    className={isNewestFirst ? undefined : styles.flipped}
                    onClick={onToggleOrder}
                >
                    <ArrowDownIcon />
                </IconButton>
            </div>

            <div className={styles.list}>
                {items.length > 0 ? (
                    items.map((item) => {
                        const date = formatDate(item.date);
                        const showDate = date !== renderedDate;
                        renderedDate = date;

                        return (
                            <Fragment key={item.id}>
                                {showDate && <div className={styles.date}>{date}</div>}

                                <NewsListItem
                                    item={item}
                                    isActive={item.id === activeId}
                                    onSelect={onSelect}
                                />
                            </Fragment>
                        );
                    })
                ) : (
                    <EmptyState
                        title="Ничего не нашлось"
                        description="Поиск идёт по заголовку и тексту новости."
                        action={isFiltered ? { label: 'Сбросить фильтры', onClick: onReset } : undefined}
                    />
                )}
            </div>
        </Panel>
    );
}